import React, { useContext, useEffect, useState } from "react";
import Helmet from "react-helmet";
// import { img_user, verified_check } from 'assets/images';
import { Context } from "../../../context/globalContext";
import { useQuery } from "@apollo/client";
import { Button } from "../../genericComponents";
import styled from "styled-components";
import avatarImage from "../../../assets/images/sprites/avatar-person.svg";
// import verifiedCheck from "../../../assets/images/sprites/verified_check.svg";
// import editIcon from "../../../assets/images/icons/edit.png";
import { ThemeProps } from "../../genericComponents/globalStyles";
import { CONNECTED_USERS } from "../../../helpers/graphqlQueries";
import { redirectToRocketDM } from "../../../helpers/utils";
import useConnectionUsers from "../../hook/useConnectionUsers";
import BadgesImages from "../../genericComponents/badges"

export default function ProfileInfo({
  image,
  setIsShowModalEditProfileState,
  owner,
  userSearchProfile,
}) {
  const [onConnect, setOnConnect] = useState(false);
  const { handleConnect } = useConnectionUsers(onCompleted, onError);
  const {
    state: { user: userProfile },
  } = useContext(Context);
  const {
    data: connectResponse,
    refetch: fetchConnect,
  } = useQuery(CONNECTED_USERS, {
    variables: { username: userProfile.username },
  });

  function onCompleted(data) {
    fetchConnect();
  }
  function onError(data) {
    console.log(data);
  }
  useEffect(() => {
    if (connectResponse) {
      let connectresponseans = connectResponse.users_connection?.find(
        (unames) => unames?.usernames?.includes(userSearchProfile.username)
      );

      setOnConnect(connectresponseans);
    }
  }, [connectResponse]);

  const openInNewTab = (url) => {
    if (userProfile.about) {
      let link = url.replace("http://", "").replace("https://", "");
      const newWindow = window.open(
        `https://${link}`,
        "_blank",
        "noopener,noreferrer"
      );
      if (newWindow) newWindow.opener = null;
    } else {
      alert(
        "Tell them a little about yourself! 😃 In order to schedule, please complete your profile bio"
      );
    }
  };


  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <title>{`${userSearchProfile.name}`}</title>
      </Helmet>
      <ColumsProfile>
        <ImageContainer>
          {userSearchProfile?.avatar?.includes('https://')?(
            <ImgProfile alt='user' src={userSearchProfile?.avatar} />
          ):
          image? (
            <ImgProfile alt='user' src={userSearchProfile?.avatar?.includes('https://')?userSearchProfile?.avatar:image} />
          ) : (
            <ImgProfile alt='user' src={avatarImage} />
          )}
        </ImageContainer>

        <DataProfileContainer>
          <div>
            <TextLabel size={"2.9em"}>
              {
                userSearchProfile.name ? (
                  <>
                    {" "}
                    {userSearchProfile.name}{" "}
                    <TitleSubIndex>
                      {userSearchProfile.pronouns}
                    </TitleSubIndex>
                    <BadgesImages
                    user={userSearchProfile}
                    />
                  </>
                ) : (
                  owner && "Add your name by editing your details!"
                )
              }
            </TextLabel>
            <TextLabel2>@{userSearchProfile.username}</TextLabel2>
            {/* {userSearchProfile.verified && (
                <img src={verifiedCheck} alt="" />
              )} */}
            {userSearchProfile.medical_school ? (
              <TextLabel2>{userSearchProfile.medical_school}</TextLabel2>
            ) : owner ? (
              <TextLabel2> Add your career too!</TextLabel2>
            ) : null}

            {owner &&
              !(
                userSearchProfile?.class_status ||
                userSearchProfile?.career ||
                userSearchProfile.honors
              ) && (
                <ChipsContainer>
                  <Text>
                    👀 Nothing to see here yet! Edit your details to finish your
                    profile!
                  </Text>
                </ChipsContainer>
              )}

            <UlTags>
              {userSearchProfile?.career?.length ? (
                <LiTags>
                  <ATags>{userSearchProfile.career}</ATags>
                </LiTags>
              ) : null}
              {userSearchProfile?.class_status ? (
                <LiTags>
                  <ATags>
                    {userSearchProfile.class_status}{" "}
                    {userSearchProfile?.class_status === "Fellow" ||
                    userSearchProfile?.class_status === "Resident"
                      ? null
                      : userSearchProfile?.class_status === "Admitted"
                      ? userSearchProfile?.admitted_year
                        ? `${userSearchProfile?.admitted_year} Student`
                        : null
                      : null}
                  </ATags>
                </LiTags>
              ) : null}
              {userSearchProfile?.class_status === "Applicant" ||
              userSearchProfile?.class_status === "Reapplicant"
                ? userSearchProfile?.applicant_replicant?.map((item, index) => (
                    <LiTags key={index}>
                      <ATags>{item}</ATags>
                    </LiTags>
                  ))
                : null}
              {(userSearchProfile.career?.includes(
                "Doctor of Allopathic Medicine"
              ) ||
                userSearchProfile.career?.includes(
                  "Doctor of Osteopathic Medicine"
                )) &&
                userSearchProfile?.specialties?.map((item, index) => (
                  <LiTags key={index}>
                    <ATags>{item}</ATags>
                  </LiTags>
                ))}
              {userSearchProfile.honors?.length > 0 &&
                userSearchProfile.honors.map((item, index) => (
                  <LiTags key={index}>
                    <ATags>{item}</ATags>
                  </LiTags>
                ))}
            </UlTags>
          </div>

          {userSearchProfile.about ? (
            <AboutContainer>
              <TextTitle fontSize={"2.1"}>Bio</TextTitle>
              <Text fontSize={"1.3"}>{userSearchProfile.about}</Text>
            </AboutContainer>
          ) : owner ? (
            <AboutContainer>
              <TextTitle fontSize={"2.1"}>Bio</TextTitle>
              <Text fontSize={"1.3"}>
                Share a little about yourself and feel free to brag! Healthy
                Bios get access to tutoring and mentorship in GABA’s growing
                network!
              </Text>
            </AboutContainer>
          ) : null}

          {userSearchProfile?.looking_for?.length ? (
            <LookOfferContainer>
              <TextLabelSub size={"2em"}>Looking for</TextLabelSub>
              <UlTags>
                {userSearchProfile?.looking_for?.map((item, index) => (
                  <LiTags key={index}>
                    <ATags>{item}</ATags>
                  </LiTags>
                ))}
              </UlTags>
            </LookOfferContainer>
          ) : null}
          {userSearchProfile?.can_offer?.length ? (
            <LookOfferContainer>
              <TextLabelSub size={"2em"}>I can offer</TextLabelSub>
              <UlTags>
                {userSearchProfile?.can_offer?.map((item, index) => (
                  <LiTags key={index}>
                    <ATags>{item}</ATags>
                  </LiTags>
                ))}
              </UlTags>
            </LookOfferContainer>
          ) : null}
        </DataProfileContainer>
        <EditContainer>
          {owner ? (
            <BackgroundColorButton
              backgroundColor={ThemeProps.color.gabaYellow}
              onClick={() => setIsShowModalEditProfileState(true)}
            >
              Edit Profile
            </BackgroundColorButton>
          ) : onConnect && onConnect?.sender !== "Recommended" ? (
            onConnect.status === 2 ? (
              <>
                <BackgroundColorButton
                  backgroundColor={ThemeProps.color.softPurple}
                  color={ThemeProps.color.white}
                  onClick={() =>
                    handleConnect(
                      onConnect,
                      userSearchProfile.username,
                      userProfile.username,
                      true,
                      userSearchProfile.email
                    )
                  }
                >
                  Disconnect
                </BackgroundColorButton>
                <BackgroundColorButton
                  backgroundColor={ThemeProps.color.darkGray}
                  color={ThemeProps.color.white}
                  onClick={() =>
                    redirectToRocketDM(
                      userProfile.email,
                      userSearchProfile.username
                    )
                  }
                >
                  Message
                </BackgroundColorButton>
              </>
            ) : (
              <BackgroundColorButton
                backgroundColor={ThemeProps.color.darkGray}
                color={ThemeProps.color.white}
              >
                Pending
              </BackgroundColorButton>
            )
          ) : (
            <BackgroundColorButton
              backgroundColor={ThemeProps.color.gabaYellow}
              color={ThemeProps.color.darkBlue}
              onClick={() =>
                handleConnect(
                  onConnect,
                  userSearchProfile.username,
                  userProfile.username,
                  userProfile.name,
                  userSearchProfile.email
                )
              }
            >
              Connect
            </BackgroundColorButton>
          )}

          {userSearchProfile?.can_offer?.some((ai) =>
            ["MENTORSHIP", "TUTORING", "COACHING"].includes(ai)
          ) && userSearchProfile.calendar_url ? (
            <CalendarButton
              backgroundColor={ThemeProps.color.darkGreen}
              onClick={() => openInNewTab(userSearchProfile.calendar_url)}
            >
              Schedule Session
            </CalendarButton>
          ) : null}
        </EditContainer>
      </ColumsProfile>
    </>
  );
}

const ColumsProfile = styled.div`
  color: white;
  margin-top: 94px;
  display: flex;
  @media (max-width: 720px) {
    flex-direction: column;
  }
`;

const LookOfferContainer = styled.div`
  padding-left: 12px;
`;
const AboutContainer = styled.div`
  padding: 30px;
  margin-top: 0px;
  margin-bottom: 16px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.22);
`;
const ChipsContainer = styled.div`
  padding: 10px;
  margin-top: 24px;
  margin-bottom: 0px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.22);
`;
const Text = styled.p`
  font-size: ${(p) => p.fontSize}em;
  line-height: 24px;
  margin: 8px 16px;
  font-style: italic;
`;
const TextTitle = styled.p`
  color: ${(props) => props.theme.color.gabaYellow};
  font-size: ${(p) => p.fontSize}em;
  line-height: 24px;
  margin: 30px 8px 16px;
`;
const BackgroundColorButton = styled(Button)`
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.theme.color.goodNightColor};
  padding: 10px 14px 14px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  width: 180px;
  margin-left: auto;
`;
const CalendarButton = styled(Button)`
  background-color: ${(props) => props.darkGreen};
  color: white;
  padding: 10px 14px 14px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  width: 180px;
  margin-left: auto;
`;
const UlTags = styled.ul`
  list-style: none;
`;
const LiTags = styled.li`
  margin-top: 4px;
  margin-right: 12px;
  display: inline-block;
  vertical-align: middle;
  padding: 8px 16px;
  border-radius: 6px;
  background: white;
  cursor: default;
`;
const ATags = styled.p`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 1.1em;
  font-weight: bold;
`;
const TextLabel = styled.p`
  line-height: 40px;
  font-family: "Eksell";
  font-size: ${(p) => p.size || "1.9em"};
  margin-bottom: 12px;
`;
const TextLabel2 = styled.p`
  color: #dddddd;
  line-height: 40px;
  font-weight: 10;
  font-family: "Helvetica";
  font-size: ${(p) => p.size || "1.9em"};
  margin-bottom: 12px;
`;
const TextLabelSub = styled.p`
  font-size: ${(p) => p.size || "1.9em"};
  margin-bottom: 12px;
  margin-right: 12px;
  color: ${(props) => props.theme.color.gabaYellow};
`;
const TitleSubIndex = styled.sub`
  margin-left: 10px;
  font-size: 0.45em;
  bottom: 0.7em;
  @media (max-width: 720px) {
    display: block;
    bottom: 0em;
    margin: 12px 0;
  }
`;
const ImageContainer = styled.div`
  width: 140px;
  height: 140px;
  margin-right: 16px;
  @media (max-width: 720px) {
    width: 100%;
    text-align: center;
    margin: 16px 0;
  }
`;
const DataProfileContainer = styled.div`
  margin-left: 50px;
  flex:1;
  display: flex;
  flex-direction: column;
  @media (max-width: 720px) {
    margin-left: 20px;
  }
`;
const ImgProfile = styled.img`
  width: 140px;
  height: 140px;
  border-radius: 140px;
`;
const EditContainer = styled.div`
  margin-left: 69px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (max-width: 720px) {
    margin-left: 20px;
  }
`;
const MessagetButton = styled(Button)`
  background: ${(props) => props.theme.color.softPurple};
  color: ${(props) => props.theme.color.black};
`;
